/** Стиль-пак «dark-mystic» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'dark-mystic',
  shape: {
    radiusCard: 24, radiusOption: 20, radiusButton: 'pill', radiusImage: 16,
    borderWidth: 2, borderTone: 'none', selectionMode: 'ring', shadow: 'none',
  },
  density: { optionHeight: 60, optionPadY: 16, optionPadX: 20, gap: 12, contentMaxWidth: 520, screenPadX: 20 },
  type: {
    headingFamily: 'serif', h1Size: 32, h1Weight: 700, h1Tracking: 0,
    qSize: 24, qWeight: 700, qTracking: 0, optionSize: 14, optionWeight: 600,
    headingAlign: 'center', overlineTransform: 'uppercase',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: true, backButton: 'icon-bare', logo: 'center' },
  cta: { placement: 'inline', fullWidth: true, height: 56, disabledStyle: 'muted-brand' },
  states: { selected: 'ring', hoverTint: false, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'icon-circle', overlayTone: 'brand', frame: 'circle',
    promptHint: 'symbolic line icon, single accent color, dark background, no photo',
  },
  // Astroline: символ и текст держатся середины экрана; глубокий фон под ними
  // затемняется ровно, иначе кремово-золотая антиква теряет контраст.
  layout: { alignY: 'center', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // Astroline: одна медленная полоса без стадий, а ожидание держат карточки
  // с ТВОИМИ ответами — «система читает именно твои данные».
  loader: {
    style: 'plain-bar', showPercent: false, socialProof: 'review',
    answersSummary: true, engagementModals: true,
  },
  // Astroline: таймера нет — срочность держит сам ритуал; цена подаётся как
  // сумма пробных двух недель, коралловый чип сидит на СТЫКЕ карточек, а
  // невыбранный тариф гаснет до ~0.5. Страница короткая, sticky-хедера нет.
  paywall: {
    timer: 'none', promoTicket: 'none', priceMode: 'trial-total',
    planHighlight: 'chip-on-seam', dimUnselectedPlans: true,
    stickyHeader: false, repeatPurchaseBlock: false,
  },
  // Мистический пак: кремово-золотой — премиальность, мятно-зелёный —
  // гарантия и безопасный чекаут.
  accents: { money: 'success', premium: 'accent' },
};
